import React from 'react';
import PropTypes from 'prop-types';
import '../style/ofertacard.css';

const OfertaCard = ({ label, icon, color, description, onClick }) => {
  return (
    <div className="ofertacard-card" style={{ borderColor: color }}>
      <button className="ofertacard-button" onClick={onClick}>
        <div className="ofertacard-icon" style={{ color }}>{icon}</div>
        <div className="ofertacard-label">{label}</div>
        <div className="ofertacard-color-bar" style={{ '--accent-color': color }}></div>
        <div className="ofertacard-overlay">
          <p>{description}</p>
        </div>
      </button>
    </div>
  );
};

OfertaCard.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  color: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onClick: PropTypes.func // 👈 dodane
};

export default OfertaCard;
